import React, { useEffect, useRef, useState } from "react";
import TextField from "../../customComponent/TextField";
import { FaCloudUploadAlt, FaTrashAlt } from "react-icons/fa";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import SuccessBackground from "../../../asesst/SuccessBackground.svg";
import file_image from "../../../asesst/file_image.png";
import Tick from "../../../asesst/tick.svg";
import Breadcrumbs from "../../customComponent/BreadCrumbs";
import { ImageBaseUrl, breadcrumbNameMap } from "../../utils/helperData";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { TfiDownload } from "react-icons/tfi";
import { RxCrossCircled } from "react-icons/rx";
import {
  EditInspectors,
  GetInspectorsDetails,
  uploadEditFiles,
} from "../../../redux/action/InspectorManagement/AddInspectorAction";
import { MANAGE_INSPECTOR } from "../../utils/RouteConstant";

const EditInspector = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [previouslyUploadedFiles, setPreviouslyUploadedFiles] = useState([]);
  const [imageToDelete, setImageToDelete] = useState(null);
  const [filesModified, setFilesModified] = useState(false);
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState({});
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    user_type: "",
    country_code: "",
    mobile: "",
    employee_id: "",
  });

  const [editCofirmationModal, setEditCoonfirmationModal] = useState(false);
  const handleEditCofirmationModal = () => {
    setEditCoonfirmationModal(true);
  };
  const handleCloseConfirmationModal = () => {
    setEditCoonfirmationModal(false);
  };
  const { inspectorId } = useParams();
  const inspectorDetails = useSelector(
    (state) => state.inspector.inspectorDetails
  );
  const error = useSelector((state) => state.inspector);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "first_name",
      "email",
      "mobile",
      "employee_id",
      "user_type",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field].trim()) {
        newErrors[field] = `${field.replace("_", " ")} is required.`;
      }
    });
    if (formData.email) {
      if (!isValidEmail(formData.email)) {
        newErrors.email =
          "Please enter a valid email address (e.g., example@domain.com).";
      }
    }
    if (formData.mobile.length !== 10 || /\D/.test(formData.mobile)) {
      newErrors.mobile =
        "Mobile number should be exactly 10 digits and contain only numbers.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    if (inspectorId) {
      dispatch(GetInspectorsDetails(inspectorId));
    }
  }, [inspectorId, dispatch]);

  useEffect(() => {
    if (inspectorDetails) {
      setFormData({
        ...formData,
        first_name: inspectorDetails.first_name || "",
        last_name: inspectorDetails?.last_name || "",
        email: inspectorDetails.email || "",
        user_type: inspectorDetails.user_type
          ? { 2: "User", 3: "Inspector" }[inspectorDetails.user_type] || "-"
          : "",
        country_code: inspectorDetails.country_code || "",
        mobile: inspectorDetails.mobile || "",
        employee_id: inspectorDetails.employee_id || "",
        user_id: inspectorDetails?._id || "",
      });
      setSelectedFiles(inspectorDetails?.supporting_doc || []);
    }
  }, [inspectorDetails]);

  const handleDeleteImage = (e, image) => {
    e.stopPropagation();
    e.preventDefault();
    setImageToDelete(image);
    setDeleteConfirmationModal(true);
  };

  const cancelDeleteImage = () => {
    setDeleteConfirmationModal(false);
    setImageToDelete(null);
  };

  const handleOpenModal = () => {
    setSelectedFiles(selectedFiles || []);
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);

const handleChange = (e) => {
  const { name, value } = e.target;
  if (name === "mobile") {
    const numericValue = value.replace(/[^0-9]/g, "");
    if (numericValue.length <= 10) {
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    }
  } else {
    setFormData({
      ...formData,
      [name]: value,
    });
  }
};

  const handleBrowseFiles = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const confirmDeleteImage = () => {
    setSelectedFiles((prevFiles) => {
      if (!Array.isArray(prevFiles)) return [];
      return prevFiles.filter((file) => {
        if (typeof imageToDelete === "string") {
          if (typeof file === "string") {
            return file !== imageToDelete;
          }
          return file.filePath !== imageToDelete;
        }
        if (imageToDelete?.filePath) {
          if (typeof file === "string") {
            return file !== imageToDelete.filePath;
          }
          return file.filePath !== imageToDelete.filePath;
        }
        if (imageToDelete instanceof File) {
          if (file instanceof File) {
            return file.name !== imageToDelete.name;
          }
          return true;
        }
        return true;
      });
    });
    if (typeof imageToDelete === "object" && imageToDelete instanceof File) {
      URL.revokeObjectURL(imageToDelete);
    }
    setDeleteConfirmationModal(false);
    setImageToDelete(null);
    setFilesModified(true);
  };

const handleUpload = async () => {
  const newFiles = selectedFiles.filter((file) => {
    return !previouslyUploadedFiles.some(
      (prevFile) =>
        prevFile.originalName === file.originalName ||
        prevFile.fileName === file.fileName
    );
  });

  // console.log("New Files to Upload:", newFiles); 

  if (newFiles.length > 0) {
    try {
      const uploadResponse = await dispatch(uploadEditFiles(newFiles));
      if (uploadResponse?.success && uploadResponse?.data) {
        // setSelectedFiles((prev) => [...prev, ...uploadResponse.data.data]);
        setPreviouslyUploadedFiles((prev) => [...prev, ...newFiles]);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  } else {
    console.log("No new files to upload.");
  }
  handleCloseModal();
};


  const normalizeFileData = (file) => {
   if (!file) return null;
   if (file instanceof File) {
     return {
       originalName: file.name,
       fileName: `${Date.now()}-${Math.random().toString(36).substr(0, 5)}-${
         file.name
       }`,
       filePath: `${Date.now()}-${Math.random().toString(36).substr(0, 5)}-${
         file.name
       }`,
       fileSize: file.size,
       fileType: file.type,
     };
   }
    if (typeof file === "string") {
      return {
        filePath: file,
        fileName: file,
        fileSize: 0,
        fileType: "application/octet-stream",
        originalName: file,
      };
    }
    if (file.fileName && file.filePath) {
      return file;
    }

    if (typeof file === "object") {
      return {
        filePath: file.filePath,
      };
    }
    return null;
  };

const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  const validFiles = files.filter((file) => {
    const isValidType = ["image/jpeg", "image/png", "application/pdf"].includes(
      file.type
    );
    const isValidSize = file.size <= 10 * 1024 * 1024; // 10MB

    if (!isValidType) {
      alert("Only .jpg, .png and pdf formats are allowed");
    }
    if (!isValidSize) {
      alert("File size should be less than 10MB");
    }
    return isValidType && isValidSize;
  });

  if (validFiles.length > 0) {
    setSelectedFiles((prevFiles) => {
      const existingFiles = new Set(
        prevFiles.map((file) => file.originalName || file.fileName)
      );
      const newFiles = validFiles
        .map((file) => normalizeFileData(file))
        .filter((newFile) => !existingFiles.has(newFile.originalName)); // Filtering out existing files

      return [...prevFiles, ...newFiles];
    });
    setFilesModified(true);
  }
};

  const handleRemoveFile = (fileIdentifier) => {
    setSelectedFiles((prevFiles) => {
      if (!Array.isArray(prevFiles)) return [];

      return prevFiles.filter((file) => {
        if (!file) return false;

        const fileName =
          file instanceof File
            ? file.name
            : typeof file === "string"
            ? file
            : file?.originalName || file?.fileName;

        return fileName !== fileIdentifier;
      });
    });
    setFilesModified(true);
  };

  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const processedFormData = { ...formData };
    if (processedFormData.user_type === "User") {
      processedFormData.user_type = "2";
    } else if (processedFormData.user_type === "Inspector") {
      processedFormData.user_type = "3";
    }

    const processedFiles = (Array.isArray(selectedFiles) ? selectedFiles : [])
      .map((file) => normalizeFileData(file))
      .filter(Boolean);

    const payload = {
      ...processedFormData,
      files: processedFiles,
    };

    try {
      const response = await dispatch(EditInspectors(payload));
      // console.log("handle submit response", response);
      if (response && response.success) {
        handleEditCofirmationModal();
      } else {
        const errorMessage = response?.message || "something went wrong";
        console.error("Response failed:", errorMessage);
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error("Error updating inspector details:", error);
    }
  };
  const downloadFile = (e, fileUrl, fileName) => {
    e.preventDefault();
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("An error occurred while downloading the file."));
  };

  const handleCancel = () => {
    navigate(MANAGE_INSPECTOR);
  };

  const handleConfirmEdit = () => {
    handleCloseConfirmationModal();
    handleOpenSaveModal();
  };
  const handleOpenSaveModal = () => setOpenSaveModal(true);
  const handleCloseSaveModal = () => {
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      user_type: "",
      country_code: "",
      mobile: "",
      employee_id: "",
    });
    setOpenSaveModal(false);
    navigate(MANAGE_INSPECTOR);
  };

  const truncateString = (str) => {
    if (str?.length > 15) {
      return str.slice(0, 15) + "...";
    }
    return str;
  };
  const renderFileList = () => {
    return selectedFiles?.map((file, index) => {
      const normalizedFile = normalizeFileData(file);
      if (!normalizedFile) return null;
      const imageElements = selectedFiles.map((image) => image);
    //  console.log("Selected Files:", selectedFiles);
    //  console.log("Normalized File Data:", normalizedFile);

      const fileName =
        normalizedFile.originalName ||
        normalizedFile.fileName ||
        file ||
        imageElements;
      const fileUrl = normalizedFile.filePath
        ? `${ImageBaseUrl}${normalizedFile.filePath}`
        : URL.createObjectURL(file);

      return (
        <div
          key={index}
          className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
        >
          <div className="flex items-center space-x-3">
            <img
              // src={fileUrl || imageElements}
              src={file_image}
              alt="Inspector Document"
              className="w-12 h-12 rounded-lg"
            />
            <div>
              <p className="font-semibold">
                {normalizedFile.filePath.length > 10
                  ? normalizedFile.filePath.slice(0, 12) + "..."
                  : normalizedFile.filePath}
              </p>
            </div>
          </div>
          <button
            className="text-[#1C3664]"
            onClick={(e) => downloadFile(e, fileUrl, fileName)}
          >
            <TfiDownload size={24} />
          </button>
          <button
            className="text-red-500"
            onClick={(e) => handleDeleteImage(e, normalizedFile)}
          >
            <FaTrashAlt size={24} />
          </button>
        </div>
      );
    });
  };
  return (
    <div>
      <div className=" mb-6">
        <h2 className="text-3xl font-bold mb-6">User / Guest Management</h2>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <form onSubmit={handleSubmit} ref={formRef}>
          <div>
            <h3 className="text-base font-base text-[#1C3664] mb-2">
              Personal Details
            </h3>
            <div
              style={{ borderBottom: "3px solid #1C3664", width: "4%" }}
            ></div>
            <div className="space-y-4 md:space-y-6 pt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {["first_name", "last_name", "mobile", "email"].map((field) => (
                  <TextField
                    key={field}
                    label={`${field
                      .replace("_", " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())}${
                      field !== "last_name" ? " *" : ""
                    }`}
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    required={field !== "last_name"}
                    error={!!errors[field]}
                    helperText={errors[field] || ""}
                  />
                ))}

                <select
                  name="user_type"
                  value={formData?.user_type}
                  onChange={handleChange}
                  className="block w-full border p-2 h-[53px] border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required
                >
                  <option value="" disabled>
                    Select User Type
                  </option>
                  <option value="User">User</option>
                  <option value="Inspector">Inspector</option>
                </select>
                {errors.user_type && (
                  <p className="mt-1 text-xs text-red-500">
                    {errors.user_type}
                  </p>
                )}
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-base font-base text-[#1C3664] mt-6 mb-2">
              Employment Details
            </h3>
            <div
              style={{ borderBottom: "3px solid #1C3664", width: "4%" }}
            ></div>
            <div className="space-y-4 md:space-y-6 pt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <TextField
                  label="Inspector Employee ID *"
                  value={formData?.employee_id}
                  onChange={handleChange}
                  name="employee_id"
                  required
                  error={!!errors.employee_id}
                  helperText={errors.employee_id}
                />
              </div>
              <div className="bg-white p-4 flex items-center space-x-8">
                <div>
                  <p className="text-base font-base">
                    Upload Inspector Documents
                  </p>
                  <span className="text-gray-500 text-sm">
                    Only support .jpg, .png and pdf
                  </span>
                </div>
                <div>
                  <button
                    type="button"
                    onClick={handleOpenModal}
                    className="bg-[#1C3664] flex text-white px-6 py-2 rounded-md shadow"
                  >
                    <FaCloudUploadAlt
                      style={{
                        height: "20px",
                        marginTop: "2px",
                        width: "20px",
                      }}
                    />
                    &nbsp; Upload
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {renderFileList()}
              </div>
            </div>

            <p className="text-red-400">
              {
                // error?.error?.response?.data?.result?.error ||
                error?.error?.response?.data?.message
              }
            </p>
            <div className="flex justify-end space-x-4 ">
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
              >
                Save Details
              </button>
            </div>
          </div>

          <Modal
            open={editCofirmationModal}
            className="justiify-center items-center flex"
          >
            <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[23%] mx-auto">
              <div className="text-center">
                <p className="font-normal text-lg mt-2 text-[#6D6D6D]">
                  Are you sure you want to edit?
                </p>
              </div>
              <div className="flex justify-center space-x-6 my-6">
                <button
                  type="submit"
                  onClick={handleConfirmEdit}
                  className="bg-[#FFFFFF] border w-[70px] px-4 py-2 rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={handleCloseConfirmationModal}
                  className="bg-[#1C3664] border w-[70px] text-white px-4 py-2 rounded-lg"
                >
                  No
                </button>
              </div>
            </Box>
          </Modal>
        </form>
        <br />
      </div>

      <Modal open={openSaveModal} className="justify-center items-center ">
        <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
          <RxCrossCircled
            onClick={handleCloseSaveModal}
            className="float-end top-2 h-6 w-6 cursor-pointer"
          />
          <div className="text-center inline-flex mt-8">
            <div
              className="w-[72px] h-[72px] flex items-center justify-center"
              style={{ backgroundImage: `url(${SuccessBackground}` }}
            >
              <img src={Tick} alt="Success" className="w-7 h-7" />
            </div>
          </div>
          <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
            Success
          </p>
          <span className="text-[#6D6D6D]">
            Inspector details update successfully
          </span>
          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={handleCloseSaveModal}
              className="border border-inherit px-4 py-2 rounded-lg"
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={deleteConfirmationModal}
        onClose={cancelDeleteImage}
        className="flex items-center justify-center"
      >
        <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[90%] max-w-md mx-auto">
          <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
          <p className="mb-6">Are you sure you want to delete this image?</p>
          <div className="flex justify-center space-x-4">
            <button
              onClick={confirmDeleteImage}
              className="bg-red-500 text-white px-4 py-2 rounded-lg"
            >
              Yes, Delete
            </button>
            <button
              onClick={cancelDeleteImage}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      <Modal open={openModal} className="justify-center items-center ">
        <Box className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto my-20">
          <RxCrossCircled
            onClick={handleCloseModal}
            className="float-end top-2 h-6 w-6 cursor-pointer"
          />
          <h2 className="text-lg font-bold mb-4">Documents Upload</h2>
          <p className="mb-2 text-sm text-gray-600">
            Add your documents here, and you can upload up to 5 files max
          </p>

          <div
            className="border-2 border-dashed border-gray-400 rounded-lg p-6 text-center mb-4"
            onClick={handleBrowseFiles}
          >
            <FaCloudUploadAlt className="mx-auto w-10 h-10 text-blue-600 mb-4" />
            <p className="text-sm text-gray-500">
              Drag your file(s) or{" "}
              <span className="text-blue-600 cursor-pointer">browse</span>
            </p>
            <p className="text-xs text-gray-400 mt-1">
              Max 10 MB files are allowed
            </p>
          </div>
          <input
            type="file"
            multiple
            onChange={handleFileChange}
            ref={fileInputRef}
            className="hidden"
          />

          <p className="text-xs text-gray-400">
            Only support .jpg, .png, and .pdf files
          </p>
          <div className="mt-4">
            {selectedFiles?.map((image, key) => {
              const getImageSource = (image) => {
                if (typeof image === "string") {
                  return `${ImageBaseUrl}${image}`;
                }
                if (image instanceof File) {
                  return URL.createObjectURL(image);
                }
                if (image?.filePath) {
                  return `${ImageBaseUrl}${image.filePath}`;
                }
                return "";
              };
              const getDisplayName = (image) => {
                if (typeof image === "string") {
                  return image;
                }
                if (image instanceof File) {
                  return image.name;
                }
                if (image?.originalName) {
                  return image.originalName;
                }
                return "Unknown file";
              };
              if (
                typeof image === "object" &&
                Object.keys(image).length === 0
              ) {
                return null;
              }

              const fileSize =
                image instanceof File
                  ? `${(image.size / 1024).toFixed(2)} KB`
                  : image?.fileSize
                  ? `${(image.fileSize / 1024).toFixed(2)} KB`
                  : null;

              const imageUrl = getImageSource(image);
              if (!imageUrl) return null;

              return (
                <div
                  key={key}
                  className="relative flex items-center border border-gray-200 rounded-md p-2 mb-2"
                >
                  <div className="w-10 h-10 mr-2">
                    <img
                      // src={imageUrl}
                      src={file_image}
                      alt="Inspector Document"
                      className="w-12 h-12 rounded-lg"
                    />
                  </div>
                  <div className="flex-grow">
                    <p className="font-semibold">
                      {truncateString(getDisplayName(image))}
                      {/* {getDisplayName(image)} */}
                    </p>
                    {fileSize && (
                      <p className="text-xs text-gray-500">{fileSize}</p>
                    )}
                  </div>
                  <button
                    onClick={() => handleRemoveFile(getDisplayName(image))}
                    className="absolute top-2 right-2 bg-gray-300 text-gray-600 rounded-full w-6 h-6 flex items-center justify-center"
                    type="button"
                  >
                    &times;
                  </button>
                </div>
              );
            })}
          </div>

          <div className="mt-6 flex justify-end gap-4">
            <button
              onClick={handleCloseModal}
              className="bg-gray-300 px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              onClick={() => handleUpload(selectedFiles)}
              className="bg-[#1C3664] text-white px-4 py-2 rounded-md"
            >
              Done
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default EditInspector;
